import axios from 'axios'
import { sha256 } from 'js-sha256';
import base64url from "base64url";
import config from '@/config'

const API_URL = config.API_URL

export default {
  state: {
    user_accounts_info: [],
    uuser_accounts_bill_info: [],
    user_account_residents_data: [],
    user_account_subsidy_info_data: [],
    
  },
  mutations: {
    userAccountsInfoAction: (state, response) => state.user_accounts_info = response,
    userAccountsBillInfoDataAction: (state, response) => state.uuser_accounts_bill_info = response,
    userAccountResidentsInfoDataAction: (state, response) => state.user_account_residents_data = response,
    userAccountSubsidyInfoAction: (state, response) => state.user_account_subsidy_info_data = response,
    
  },
  actions: {
    async userAccountsInfoData(ctx){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      const item =  window.location.pathname.split('/').pop()
      await axios.get(
        `${API_URL}/api/rest/receipt/account_addres_info?lico=${item}&secret_key=${key}`, 
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        const userData = response.data.items
        localStorage.setItem('weltumTimeAuth', Date.now())
        ctx.commit('userAccountsInfoAction', userData[0])
      })
    },
    async userAccountsBillInfoData(ctx){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      const item =  window.location.pathname.split('/').pop()
      await axios.get(
        `${API_URL}/api/rest/receipt/inv_lines?lico=${item}&secret_key=${key}`, 
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        const userData = response.data.items
        localStorage.setItem('weltumTimeAuth', Date.now())
        ctx.commit('userAccountsBillInfoDataAction', userData[0])
      })
    },
    async userAccountResidentsInfoData(ctx){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      const item = window.location.pathname.split('/').pop()
      await axios.get(
        `${API_URL}/api/rest/receipt/account_people_info?lico=${item}&secret_key=${key}`, 
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        const userData = response.data.items
        localStorage.setItem('weltumTimeAuth', Date.now())
        ctx.commit('userAccountResidentsInfoDataAction', userData)
      })
    },
    async userAccountSubsidyInfo(ctx){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      const item = window.location.pathname.split('/').pop()
      await axios.get(
        `${API_URL}/api/rest/receipt/account_lgot_info?lico=${item}&secret_key=${key}`, 
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        const userData = response.data.items
        localStorage.setItem('weltumTimeAuth', Date.now())
        ctx.commit('userAccountSubsidyInfoAction', userData[0])
      })
      },
      async portmonePay(ctx, account = null){
        let item = window.location.pathname.split('/').pop()
        if(account !== null) {
          item = account
        }
        window.open( `https://www.portmone.com.ua/r3/uk/services/communal/request?payee_id=29704&contract_number=${item}`);
      },
      async privatPay(ctx, account = null){
        let item = window.location.pathname.split('/').pop()
        if(account !== null) {
          item = account
        }
        window.open( `https://next.privat24.ua/payments/form/{"token":"8645c2735a4bc4a50540b183b9969ed6z4xh3v8x","personalAccount":"${item}"}`);
      },
      async ZssPay(ctx, account = null){
        let item = window.location.pathname.split('/').pop()
        if(account !== null) {
          item = account
        }
        window.open( `https://ips24.zss.zp.ua/faces/api/proc?t=Ei2yB6Ryl-_7AZhwAAXJu0cDxnrlhUufR2OHtiQGzkw.&b=${item}`);
      },
  },
  getters:{
    userAccountsinfo: s => s.user_accounts_info,
    userAccountsBillInfo: s => s.uuser_accounts_bill_info,
    userAccountResidentsData: s => s.user_account_residents_data,
    userAccountSubsidyInfoData: s => s.user_account_subsidy_info_data,
    
  },
}